import Link from 'next/link';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import { BASE_PATH } from '@config/index';
import getImageQuality from '@utils/getImageQuality';
const SimpleNavigationMobile = () => {
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.simpleNavigationMobileContentContainer}>
      <div sx={styles.menuLogoMobile}>
        <Link href="/" prefetch={false}>
          <Image data-cy="logoIcon" fill sizes="100vh" src={`${BASE_PATH}/img/logo.svg`} quality={getImageQuality()} alt={t('logoIconAlt')} priority />
        </Link>
      </div>
    </div>;
};
export default SimpleNavigationMobile;